/* Move the existing filter controls without cloning forms or losing selections. */
(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('.fl-collection').forEach(catalog => {
      if (catalog.dataset.mobileCollectionReady) return;
      catalog.dataset.mobileCollectionReady = 'true';
      const desktopSlot = catalog.querySelector('[data-collection-filter-desktop]');
      const mobileSlot = catalog.querySelector('[data-collection-filter-mobile]');
      const panel = desktopSlot?.querySelector('.fl-filters');
      const activeFilters = desktopSlot?.querySelector('.fl-active-filters');
      const trigger = catalog.querySelector('[data-collection-filter-toggle]');
      const toolbar = catalog.querySelector('.fl-collection-toolbar');
      const mobile = matchMedia('(max-width:999px)');
      const paginationLinks = [...catalog.querySelectorAll('.fl-pagination a')].map(link => ({link, href:link.href}));
      const filterLinks = [...catalog.querySelectorAll('[data-filter-reset], .fl-active-filters a')].map(link => ({link, href:link.href}));
      const form = panel?.querySelector('form');
      const originalAction = form?.action;
      if (panel && trigger) {
        panel.id = trigger.getAttribute('aria-controls');
        const count = panel.querySelector(':scope > summary .fl-filter-count')?.textContent.trim();
        const badge = trigger.querySelector('[data-collection-filter-count]');
        if (count && badge) { badge.textContent = count; badge.hidden = false; }
      }
      const syncExpanded = () => {
        if (!panel || !trigger) return;
        panel.hidden = mobile.matches && !panel.open;
        trigger.setAttribute('aria-expanded', String(mobile.matches && panel.open));
      };
      const update = () => {
        if (panel && trigger) {
          const slot = mobile.matches ? mobileSlot : desktopSlot;
          slot.append(panel);
          if (activeFilters) slot.append(activeFilters);
          panel.open = !mobile.matches;
          trigger.hidden = !mobile.matches;
          syncExpanded();
          const action = new URL(originalAction);
          if (mobile.matches) action.hash = toolbar.id;
          form.action = action.href;
        } else {
          catalog.classList.add('fc-collection-without-filters');
        }
        [...paginationLinks, ...filterLinks].forEach(({link, href}) => {
          const url = new URL(href);
          if (mobile.matches) url.hash = toolbar.id;
          link.href = url.href;
        });
      };
      trigger?.addEventListener('click', () => {
        if (!panel) return;
        panel.open = !panel.open;
        syncExpanded();
      });
      panel?.addEventListener('toggle', syncExpanded);
      catalog.addEventListener('keydown', event => {
        if (event.key === 'Escape' && mobile.matches && panel?.open) {
          panel.open = false; syncExpanded(); trigger.focus();
        }
      });
      const onResize = () => {
        if (!catalog.isConnected) { mobile.removeEventListener('change', onResize); return; }
        update();
      };
      mobile.addEventListener('change', onResize);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
